import { ApiContext } from '../../types'
import getCurrentBearerToken from '@/api_client/api/authentication/getCurrentBearerToken'

export default async function deleteProductDiscount(
  { client, config }: ApiContext,
  discount_id,
): Promise<any> {
  try {
    const token = await getCurrentBearerToken({ client, config })
    const result = await client.products.deleteProductDiscount(
      { bearerToken: token },
      discount_id,
    )

    if (result.isSuccess()) {
      const payload = result.success()
      // console.log(payload)
      // const t = deserializeTaxons([payload.data], [])
      return true
    } else {
      return false
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
